/*
 *  Filename........: departmentService.js
 *  Project.........: logistik-app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @version........: 1.0
 *    
 *  @since..........: 30.07.20, 13:47
 *  @author.........: Robin Rick
 *  
 *  @brief..........:
 */

const departmentService = {
    get(id) {
        return axios.get('/api/v1/department/' + id).then(
            (response) => {
                return response.data.data;
            }
        );
    },
    getAll() {
        return axios.get('/api/v1/department/').then(
            (response) => {
                return response.data.data;
            }
        );
    }
}

export default departmentService;